(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('cultureTransitionHook', cultureTransitionHook);

    var noop = angular.noop;

    cultureTransitionHook.$inject = ['$location', 'culture'];
    function cultureTransitionHook($location, culture) {
        return { onBefore: [{}, hook] };

        function hook(transition) {
            var search = $location.search(),
                lang = search.lang || search.culture;

            return lang ? culture.set(lang).catch(noop) : null;
        }
    }
})();